export const NECK_LABEL_DEFAULT_PDP_TYPE = "neck_label";

export type NeckLabelPageMeta = {
  catalogNumber: string;
  pdpType: string;
};

export function getOrderNumber(): string | undefined {
  // Check for browser environment
  if (typeof window === "undefined" || typeof window.jiffy === "undefined") {
    return undefined;
  }

  // Check for existence and coerce to string while preserving undefined
  if (window.jiffy.orderNumber == null) {
    return undefined;
  }

  return String(window.jiffy.orderNumber);
}

export function getNeckLabelPageMeta(): NeckLabelPageMeta {
  // Check for browser environment
  if (typeof window === "undefined" || typeof window.jiffy === "undefined") {
    return {
      catalogNumber: "",
      pdpType: NECK_LABEL_DEFAULT_PDP_TYPE
    };
  }

  const catalogNumber = String(window.jiffy.neckLabelCatalogNumber ?? "");
  const pdpType = window.jiffy.neckLabelPdpType || NECK_LABEL_DEFAULT_PDP_TYPE;

  return { catalogNumber, pdpType };
}
